import { axiosWithAuth } from "../axiosWithAuth";
import { API_BASE_URL } from "../env";
import {
  CREATE_NOTIFY,
  EP_DELETE_NOTIFY,
  EP_GET_ALL_NOTIFY,
  EP_UPDATE_NOTIFY,
} from "./api";

export const createNotify = async (requestBody?: any) => {
  let server = API_BASE_URL + CREATE_NOTIFY.path;
  let body = requestBody ? requestBody : CREATE_NOTIFY.requestBody;
  return await axiosWithAuth(server, {
    method: CREATE_NOTIFY.method,
    data: body,
  });
};

export const getAllNotifyService = async () => {
  let server = API_BASE_URL + EP_GET_ALL_NOTIFY.path;
  return await axiosWithAuth(server, {
    method: EP_GET_ALL_NOTIFY.method,
  });
};

export const updateNotifyService = async (requestBody: any) => {
  let server = API_BASE_URL + EP_UPDATE_NOTIFY.path;
  return await axiosWithAuth(server, {
    method: EP_UPDATE_NOTIFY.method,
    data: requestBody,
  });
};

export const deleteNotifyService = async (requestBody: any) => {
  let server = API_BASE_URL + EP_DELETE_NOTIFY.path;
  return await axiosWithAuth(server, {
    method: EP_DELETE_NOTIFY.method,
    data: requestBody,
  });
};
